import { useEffect, useState, useCallback } from 'react'

/**
 * Custom hook untuk mengelola fullscreen state dan toggle
 * @returns {Object} { isFullscreen, toggleFullscreen }
 */
const useFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  // Event listener untuk fullscreen change
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)

    // Set initial state
    setIsFullscreen(!!document.fullscreenElement)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    }
  }, [])

  const toggleFullscreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.()
    } else {
      document.exitFullscreen?.()
    }
  }, [])

  return { isFullscreen, toggleFullscreen }
}

export default useFullscreen
